export default __webpack_public_path__ + "static/media/instagram.7a7d31d0.svg";